import 'jquery-mask-plugin';
import moment from 'moment';

export default function Mask() {
  $('.zipcode').mask('00000-000');
  $('.cpf').mask('000.000.000-00');
  $('#input-add-docf').mask('00000000000000000000000000000000000000000000');
  $('.cnh').mask('0#');
  $('.cnpj').mask('AA.AAA.AAA/AAAA-00', {
    translation: {
      A: { pattern: /[A-Za-z0-9]/ },
    },
  });
  $('.phone').mask('(00) 00000-0000');
  $('.number').mask('#');
  $('.decimal').mask('####################0.##', {
    reverse: true,
  });
  $('.latitude').mask('-00.000000', {
    translation: {
      0: { pattern: /[0-9]/ },
      '-': { pattern: /-/, optional: true },
    },
  });

  // TODO: ajustar a máscara de longitude
  // $('.longitude').mask('-000.000000', {
  //   translation: {
  //     0: { pattern: /[0-9]/ },
  //     '-': { pattern: /[-]/, optional: true },
  //   },
  // });

  // $(".plate").mask("AAA-0000", {
  //   translation: {
  //     A: {
  //       pattern: /[A-Za-z]/
  //     }
  //   }
  // });
  $('.plate').mask('AAAAAAA', {
    translation: {
      A: {
        pattern: /[A-Za-z0-9]/,
      },
    },
  });
  // $('.rg').mask('99.999.999-9');
  $('.container-mask').mask('AAAU0000000', {
    translation: {
      A: {
        pattern: /[A-Za-z]/,
      },
      U: {
        pattern: /[UJZujz]/,
      },
    },
  });
  $('.weight').mask('00000');

  $('.date_time').mask('00/00/0000 00:00', {
    placeholder: 'dia/mês/ano  horas:minutos',
    onKeyPress: (date, _event, currentField, _options) => {
      if (date.length === 16) {
        const formatDate = moment(date, 'DD/MM/YYYY HH:mm', true);
        if (!formatDate.isValid()) {
          currentField.val('');
        }
      }
    },
  });
  $('.datetime').mask('00/00/0000 00:00', {
    placeholder: 'dia/mês/ano  horas:minutos',
    onKeyPress: (date, _event, currentField, _options) => {
      if (date.length === 16) {
        const formatDate = moment(date, 'DD/MM/YYYY HH:mm', true);
        if (!formatDate.isValid()) {
          currentField.val('');
        }
      }
    },
  });
  $('.time').mask('00:00', {
    placeholder: 'horas:minutos',
  });
  $('.time-min').mask('00:00', {
    placeholder: 'horas:minutos',
    reverse: true,
  });
  $('.date').mask('00/00/0000', {
    placeholder: 'dia/mês/ano',
    onKeyPress: (date, _event, currentField, _options) => {
      if (date.length === 10) {
        const formatDate = moment(date, 'DD/MM/YYYY', true);
        if (!formatDate.isValid()) {
          currentField.val('');
        }
      }
    },
  });
  $('.month').mask('00/0000', {
    placeholder: 'mês/ano',
    onKeyPress: (date, _event, currentField, _options) => {
      if (date.length === 7) {
        const formatDate = moment(date, 'MM/YYYY', true);
        if (!formatDate.isValid()) {
          currentField.val('');
        }
      }
    },
  });
  $('.money').mask('#.##0,00', {
    reverse: true,
  });
  $('.year').mask('0000');
  const CpfCnpjMaskBehavior = function (val) {
    const onlyAlnum = val.replace(/[^A-Za-z0-9]/g, '');
    return onlyAlnum.length <= 11
      ? '000.000.000-009999'
      : 'AA.AAA.AAA/AAAA-00';
  };
  const cpfCnpjTranslation = {
    translation: {
      A: { pattern: /[A-Za-z0-9]/ },
    },
  };
  const cpfCnpjpOptions = {
    ...cpfCnpjTranslation,
    onKeyPress(val, e, field, options) {
      field.mask(CpfCnpjMaskBehavior.apply({}, arguments), { ...cpfCnpjTranslation, ...options });
    },
  };
  $('.cpf-cnpj').mask(CpfCnpjMaskBehavior, cpfCnpjpOptions);

  $('.card-number').mask('0000 0000 0000 0000');
}

function stringToMinutes(string) {
  const splitted = string.split(':');
  const hour = parseInt(splitted[0]) * 60;
  const min = parseInt(splitted[1]);

  return hour + min;
}

function createFakeMinTimer($elem) {
  const id = $elem.attr('id');
  const non_fake_id = id.replace('_fake', '');
  const name = $elem.attr('name');
  const val = $elem.val();
  const formatted_val = stringToMinutes(val);

  const classList = $(`#${id}`).attr('class').split(/\s+/);
  $.each(classList, function (_index, item) {
    if (item.includes('timemin-')) {
      const newElement = `<input type="hidden" name="${name}" id="${id}" value="${formatted_val}" class="real-${item}">`;
      $elem.attr('id', `${non_fake_id}_fake`);
      $elem.attr('name', 'fake_timer');
      if ($(`#${non_fake_id}`).length > 0) {
        $(`#${non_fake_id}`).val(formatted_val);
      } else {
        $elem.parent().append(newElement);
      }
    }
  });
}

function createFakeCurrency($elem) {
  const id = $elem.attr('id');
  const non_fake_id = id.replace('_fake', '');
  const name = $elem.attr('name');
  const val = $elem.val();
  const formatted_val = val.replace(/\./g, '').replace(',', '.');

  const classList = $(`#${id}`).attr('class').split(/\s+/);
  $.each(classList, (_index, item) => {
    if (item.includes('value-')) {
      const newElement = `<input type="hidden" name="${name}" id="${id}" value="${formatted_val}" class="real-${item}">`;
      $elem.attr('id', `${non_fake_id}_fake`);
      $elem.attr('name', 'fake_money');
      if ($(`#${non_fake_id}`).length > 0) {
        $(`#${non_fake_id}`).val(formatted_val);
      } else {
        $elem.parent().append(newElement);
      }
    }
  });
}

function fakeCurrency() {
  $('.money').each((_i, el) => createFakeCurrency($(el)));
  $('.money').on('input change', (el) =>
    createFakeCurrency($(el.currentTarget))
  );
}

function fakeMinTime() {
  $('.time-min').each((_i, el) => createFakeMinTimer($(el)));
  $('.time-min').on('change', (el) => createFakeMinTimer($(el.currentTarget)));
}

export function initMask() {
  Mask();
  fakeCurrency();
  fakeMinTime();
}

$(() => {
  initMask();
});
